module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fsAuthorizationLetter commonStyle paddingTop45"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("签署复苏同意书")]), _vm._v(" "), _c('ul', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("1.签署复苏同意书视频")]), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "leftcon"
  }, [_c('div', {
    staticClass: "smallTitle"
  }, [_vm._v("视频一"), _c('p', {
    staticClass: "prompt"
  })]), _vm._v(" "), _c('p', {
    staticClass: "txtdection"
  }, [_vm._v("需要录像的患者需录签同意书及签署相关说明视频，视频要求能看清楚签名，和签署人的正面")])])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    ref: "video1Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.video1Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "video/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 1, 'video1')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.video1Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('video1')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    nativeOn: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.video1Look)
      }
    }
  }, [_c('video', {
    attrs: {
      "controls": "controls",
      "preload": "auto",
      "webkit-playsinline": "false",
      "playsinline": "false",
      "x-webkit-airplay": "true",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "true",
      "x5-video-ignore-metadata": "true"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.lookList.video1Look,
      "type": "video/mp4; codecs=\"avc1.42E01E, mp4a.40.2\""
    }
  }), _vm._v("\n                  你的浏览器不支持H5播放器\n                ")])])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "leftcon"
  }, [_c('div', {
    staticClass: "smallTitle"
  }, [_vm._v("视频二"), _c('p', {
    staticClass: "prompt"
  })]), _vm._v(" "), _c('p', {
    staticClass: "txtdection"
  }, [_vm._v("需要患者把相关说明再念一次的视频")])])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    ref: "video2Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.video2Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "video/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 1, 'video2')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.video2Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('video2')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.video2Look)
      }
    }
  }, [_c('video', {
    attrs: {
      "controls": "controls",
      "preload": "auto",
      "webkit-playsinline": "false",
      "playsinline": "false",
      "x-webkit-airplay": "true",
      "x5-video-player-type": "h5",
      "x5-video-player-fullscreen": "true",
      "x5-video-ignore-metadata": "true"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.lookList.video2Look,
      "type": "video/mp4; codecs=\"avc1.42E01E, mp4a.40.2\""
    }
  }), _vm._v("\n                  你的浏览器不支持H5播放器\n                ")])])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.单位证明（单位公章）")]), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    ref: "dwzmImageLook",
    staticClass: "rightcon"
  }, [(_vm.lookList.dwzmImageLook == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'dwzmImage')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.dwzmImageLook) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('dwzmImage')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.dwzmImageLook)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    ref: "dwzmImage",
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.dwzmImageLook,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.视频本人身份证复印件（签字并盖手印）")]), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    ref: "spbrSfzImageLook",
    staticClass: "rightcon"
  }, [(_vm.lookList.spbrSfzImageLook == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'spbrSfzImage')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.spbrSfzImageLook) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('spbrSfzImage')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.spbrSfzImageLook)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.spbrSfzImageLook,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    ref: "tysxgsmImageLook",
    staticClass: "rightcon"
  }, [(_vm.lookList.tysxgsmImageLook == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'tysxgsmImage')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.tysxgsmImageLook) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('tysxgsmImage')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.tysxgsmImageLook)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.tysxgsmImageLook,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    ref: "fsyztysImage1Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.fsyztysImage1Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'fsyztysImage1')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.fsyztysImage1Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('fsyztysImage1')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.fsyztysImage1Look)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.fsyztysImage1Look,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    ref: "fsyztysImage2Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.fsyztysImage2Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'fsyztysImage2')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.fsyztysImage2Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('fsyztysImage2')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.fsyztysImage2Look)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.fsyztysImage2Look,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    ref: "artTdtysImage1Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.artTdtysImage1Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'artTdtysImage1')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.artTdtysImage1Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('artTdtysImage1')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.artTdtysImage1Look)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.artTdtysImage1Look,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    ref: "artTdtysImage2Look",
    staticClass: "rightcon"
  }, [(_vm.lookList.artTdtysImage2Look == '' && _vm.status != 1) ? _c('div', {
    staticClass: "lsbg"
  }, [_c('div', {
    staticClass: "uploadIcon"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2, 'artTdtysImage2')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-iconset0239 iconfont",
    staticStyle: {
      "font-size": "30px",
      "color": "#fff"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e(), _vm._v(" "), (_vm.lookList.artTdtysImage2Look) ? _c('div', [(_vm.status != 1 && !_vm.canEdit) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick('artTdtysImage2')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.lookList.artTdtysImage2Look)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.lookList.artTdtysImage2Look,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), (_vm.status != 1) ? _c('x-button', {
    staticClass: "BtnCommonCss",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.canEdit ? '修改' : '提交审核'))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-filingInformation",
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('div', {
    staticClass: "dialogCon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.dialogSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#E64340",
      "border-radius": "45px",
      "z-index": "5001",
      "position": "absolute",
      "right": "-15px",
      "top": "-15px",
      "width": "40px",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-close-empty",
    staticStyle: {
      "fill": "#fff"
    },
    attrs: {
      "type": "ios-close-empty",
      "size": "40",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"
    }
  })])])]), _vm._v(" "), _c('confirm', {
    attrs: {
      "title": "提示"
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("该图片删除后将无法恢复，确认删除吗？")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("4.关于通过视频方式签订人类辅助生殖治疗同意书的相关说明（签字并盖手印）"), _c('a', {
    attrs: {
      "href": "https://front.cd.jinxin-fertility.com/file/%E5%85%B3%E4%BA%8E%E9%80%9A%E8%BF%87%E8%A7%86%E9%A2%91%E6%96%B9%E5%BC%8F%E7%AD%BE%E8%AE%A2%E5%86%B7%E5%86%BB%E8%83%9A%E8%83%8E%E8%A7%A3%E5%86%BB%E7%A7%BB%E6%A4%8D%E7%9F%A5%E6%83%85%E5%90%8C%E6%84%8F%E4%B9%A6ART%E5%A4%9A%E8%83%8E%E5%A6%8A%E5%A8%A0%E5%87%8F%E8%83%8E%E7%9F%A5%E6%83%85%E5%90%8C%E6%84%8F%E4%B9%A6%E7%9A%84%E7%9B%B8%E5%85%B3%E8%AF%B4%E6%98%8E.pdf"
    }
  }, [_vm._v("文件下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("5.复苏移植知情同意书（2张）"), _c('a', {
    attrs: {
      "href": "https://front.cd.jinxin-fertility.com/file/%E5%86%B7%E5%86%BB%E8%83%9A%E8%83%8E%E8%A7%A3%E5%86%BB%E7%A7%BB%E6%A4%8D%E7%9F%A5%E6%83%85%E5%90%8C%E6%84%8F%E4%B9%A6.pdf"
    }
  }, [_vm._v("文件下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("6.ART多胎妊娠减胎知情同意书（2张）"), _c('a', {
    attrs: {
      "href": "https://front.cd.jinxin-fertility.com/file/ART%E5%A4%9A%E8%83%8E%E5%A6%8A%E5%A8%A0%E5%87%8F%E8%83%8E%E7%9F%A5%E6%83%85%E5%90%8C%E6%84%8F%E4%B9%A6.pdf"
    }
  }, [_vm._v("文件下载")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdae849","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/selfHelpFilingProject/fsAuthorizationLetter.vue
// module id = EvWL
// module chunks = 7